import React from 'react';
import PropTypes from 'prop-types';
import ToolTip from '../../../Shared/ToolTip/ToolTip';
import { TOOLTIP_POSITION_BOTTOM } from '../../../../utils/dom-utils';

const IClassFundToolTip = ({ fundName }) => {
  const hasFund = fundName.toLowerCase().includes('fund');
  return (
    <ToolTip
      theme="dark"
      header={<h4 className="inline-message-tooltip_title">I Class Shares</h4>}
      maxNoteWidth="400px"
      message={
        <div className="inline-message-tooltip">
          <p className="inline-message-tooltip_main">
            When available, I Class shares of our mutual funds generally have
            lower costs than Investor Class shares of the same fund.
          </p>
          <p class="inline-message-tooltip_main">
            For qualifying accounts in the Summit Program, Investor Class shares
            are eligible for conversion to corresponding I Class shares when you
            meet the following requirements:
            <br />
            <br />
            <ul>
              <li>
                Personal Services or Enhanced Personal Services member in the
                Summit Program; and Fund balance of at least $50,000.00
              </li>
            </ul>
          </p>
          <p className="inline-message-tooltip_main">
            <strong>Automated Conversions:</strong> Accounts holding Investor
            Class shares will be periodically reviewed to determine whether they
            are eligible for conversion to I Class shares. You will receive a
            notification prior to our automated conversion process. If eligible
            and you don't want to wait, please contact T. Rowe Price at
            1-800-779-4393 and request I Class for your eligible holdings.
          </p>
        </div>
      }
      callerText={
        <span className="bold">
          {fundName} {hasFund ? '' : 'Fund'} - I Class
        </span>
      }
      placement={TOOLTIP_POSITION_BOTTOM}
    />
  );
};

IClassFundToolTip.propTypes = {
  fundName: PropTypes.string,
};

export default IClassFundToolTip;
